import Repository from "@/api/repository";
import { baseUrl } from "@/api/omni3/v1/base";
const resource = `${baseUrl}/wellplates`;
export default {
    getDefaultWellPlates() {
        return Repository.get(resource);
    }
};
